import axios from "axios";

export default function updateAssign({ payload }) {
  return new Promise((resolve, reject) =>
    axios
      .post("/distributor/system-admin/api/v1/reassignV2", {
        branch_uuid: payload.branchUuid,
        product_uuid: payload.productUuid,
        format: payload.format,
        ranges: payload.ranges,
        force_reassign: payload.forceReassign,
      })
      .then((response) => resolve(response.data))
      .catch((error) => {
        if (error.response && error.response.data) {
          const err = new Error(error.response.data.message);
          err.data = error.response.data;
          reject(err);
        }
      })
  );
}
